(function () {
  document.querySelectorAll('[data-countdown-timer]').forEach(function (root) {
    var targetRaw = root.getAttribute('data-target');
    if (!targetRaw) return;

    // Accept "YYYY-MM-DD HH:MM" and normalize to a format every browser
    // parses consistently as local time.
    var isoish = targetRaw.trim().replace(' ', 'T');
    var target = new Date(isoish);
    if (isNaN(target.getTime())) return;

    var digitsEl = root.querySelector('[data-countdown-digits]');
    var expiredEl = root.querySelector('[data-countdown-expired]');
    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');
    var msEl = root.querySelector('[data-countdown-milliseconds]');

    function pad(num) {
      return String(num).padStart(2, '0');
    }

    function tick() {
      var diff = target.getTime() - Date.now();

      if (diff <= 0) {
        if (digitsEl) digitsEl.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        clearInterval(timer);
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      var ms = Math.floor((diff % 1000) / 10); // two-digit hundredths

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
      if (msEl) msEl.textContent = pad(ms);
    }

    tick();
    var timer = setInterval(tick, 30);
  });
})();
